module.exports = {"formbody":{"header":{"headline":"<span>הדילמה</span> שלי","desc":"<span>בחיים יש לנו לא מעט דילמות.</span><br/>לקנות דירה או להשקיע בחיסכון?<br/>ללמוד לתואר שני או לחפש עבודה אחרת? מלאו את הפרטים שלכם, ספרו לנו על דילמה כלכלית שאתם ניצבים בפניה ואולי תקבלו עזרה מקצועית מהמומחים."},"form":{"FullName":"שם מלא","Age":"גיל","Phone":"טלפון","Email":"דוא\"ל","MyDilemmaDesc":"הדילמה הכלכלית שלי","button":"שלח","taknon":"אישור <a href=\"https://z.ynet.co.il/mShort/commerce/2018/MyDilemmaAPI/taknon.htm\" title=\"\" target=\"_blank\">תקנון</a>"}}}


//////////////////
// WEBPACK FOOTER
// ./src/api/data.json
// module id = 32
// module chunks = 0